import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { GameServices } from '../../services/game-services';
import { BlocksStylesType } from '../../model/blocks-types';

export class LoadingCellViewModel {
  public get cellColor() {
    const rowStripe = this.row < 3 || this.row > 5;
    const colStripe = this.column < 3 || this.column > 5;
    return (rowStripe && colStripe) || (!rowStripe && !colStripe)
      ? this.gameServices.gameThemeService.getNumericalRGB(BlocksStylesType.CellAFill)
      : this.gameServices.gameThemeService.getNumericalRGB(BlocksStylesType.CellBFill);
  }
  public get cellAlpha() {
    const rowStripe = this.row < 3 || this.row > 5;
    const colStripe = this.column < 3 || this.column > 5;
    return (rowStripe && colStripe) || (!rowStripe && !colStripe)
      ? this.gameServices.gameThemeService.getNumericalAlpha(BlocksStylesType.CellAFill)
      : this.gameServices.gameThemeService.getNumericalAlpha(BlocksStylesType.CellBFill);
  }
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }

  constructor(
    private gameServices: GameServices,
    readonly row: number,
    readonly column: number,
  ) {}

  public calculateScaleFactor(gameSizeMetrics: GameSizeMetrics): {
    scaledOffsetX: number;
    scaleFactor: number;
  } {
    return this.gameServices.gameMetricsService.calculateBoardScaling(gameSizeMetrics);
  }
}
